module.exports = __webpack_public_path__ + "static/img/new_logo.eaf9c916.png";